import { API_ENDPOINTS } from "../config/api";
import { apiRequest } from "./httpClient";

export const getAllBlogs = async ({ page, size, search, location, category }) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("size", size);

  if (!API_ENDPOINTS?.BLOGS) {
    throw new Error("Endpoint de blogs não configurado");
  }

  return apiRequest(
    `${API_ENDPOINTS.BLOGS}?${params.toString()}&sort=createdAt,desc`,
    {
      fallbackMessage: "Erro ao buscar blogs",
      errorCode: "BLOG_LIST_FAILED",
    }
  );
};

export const getSimilarVacancies = async (id) => {
  if (!API_ENDPOINTS?.VACANCIES) {
    throw new Error("Endpoint de vagas não configurado");
  }

  return apiRequest(`${API_ENDPOINTS.VACANCIES}/similar/${id}`, {
    fallbackMessage: "Erro ao buscar vagas",
    errorCode: "SIMILAR_VACANCIES_FAILED",
  });
};

export const getJobCategories = async () => {
  if (!API_ENDPOINTS?.VACANCIES) {
    throw new Error("Endpoint de vagas não configurado");
  }

  return apiRequest(`${API_ENDPOINTS.VACANCIES}/categories`, {
    fallbackMessage: "Erro ao buscar categorias",
    errorCode: "VACANCY_CATEGORIES_FAILED",
  });
}

export const getBlogById = async (blogId) => {
  return apiRequest(`${API_ENDPOINTS.BLOGS}/${blogId}`, {
    fallbackMessage: `Failed to fetch blog with ID: ${blogId}`,
    errorCode: "BLOG_FETCH_FAILED",
  });
};

export const getBlogCategoryById = async (categoryId) => {
  return apiRequest(`${API_ENDPOINTS.BLOGS_CATEGORIES}/${categoryId}`, {
    fallbackMessage: `Failed to fetch blog category with ID: ${categoryId}`,
    errorCode: "BLOG_CATEGORY_FETCH_FAILED",
  });
};

export const getAllBlogCategories = async (categoryId) => {
  return apiRequest(`${API_ENDPOINTS.BLOGS_CATEGORIES}`, {
    fallbackMessage: "Failed to fetch blogs categories",
    errorCode: "BLOG_CATEGORIES_FETCH_FAILED",
  });
};





